import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { Box, Chip } from '@mui/material'
import Button from '@mui/material/Button'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { connect } from 'react-redux'
import {
	deleteSubControl,
	resetControlVirtualState,
	runSubControl,
} from '../../store/HouseContainer/operations'
import { Control, State, SubControl } from '../../types'
import {
	isHpMachineCategory,
	isStepMachineCategory,
	isTwayMachineCategory,
} from '../../utils'

type OProps = {
	control: Control
	subControl: SubControl
	keyi: string
}

type Props = {
	control: Control
	subControl: SubControl
	keyi: string
	disabled: boolean
	editMode: boolean

	deleteSubControl: (subControl: SubControl) => void
	runSubControl: (subControl: SubControl) => void
	resetControl: (subControl: SubControl) => void
}

function Container(props: Props) {
	const { control, subControl } = props
	const isStep = isStepMachineCategory(control.category)
	const showInfo =
		!isHpMachineCategory(control.category) &&
		!isTwayMachineCategory(control.category)
	const seconds = (control.timer * subControl.rate) / 100

	return (
		<ListItem
			data-test={`subControl-item-${props.keyi}`}
			sx={{
				py: 0.5,
				px: 1,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 1,
				flexWrap: 'wrap',
			}}
		>
			{showInfo && (
				<Box
					sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}
				>
					<Typography variant="body2" sx={{ fontWeight: 600 }}>
						{subControl.name}
					</Typography>
					<Chip
						size="small"
						variant="outlined"
						label={`${subControl.rate}%${isStep ? '開' : ''}`}
						sx={{ height: 20 }}
					/>
					<Typography
						variant="caption"
						color="text.secondary"
						sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25 }}
					>
						<AccessTimeIcon sx={{ fontSize: 14 }} />
						{seconds}秒
					</Typography>
				</Box>
			)}

			<Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
				{props.editMode ? (
					<>
						<Button
							size="small"
							disabled={props.disabled}
							variant="outlined"
							onClick={() => props.resetControl(subControl)}
							data-test={`control-reset-btn-${props.keyi}`}
						>
							補正する
						</Button>
						<Button
							size="small"
							disabled={props.disabled}
							variant="outlined"
							color="error"
							onClick={() => props.deleteSubControl(subControl)}
							data-test={`control-del-btn-${props.keyi}`}
						>
							削除する
						</Button>
					</>
				) : (
					showInfo && (
						<Button
							size="small"
							variant="contained"
							disableElevation
							disabled={props.disabled}
							onClick={() => {
								if (!window.confirm('自動制御がオフになりますが実行しますか？'))
									return
								props.runSubControl(subControl)
							}}
						>
							実行
						</Button>
					)
				)}
			</Box>
		</ListItem>
	)
}

const ms = (state: State, op: OProps) => ({
	...op,
	disabled: state.Network.isLoading,
	editMode: state.SettingContainer.editControl,
})

const conn = connect(ms, {
	deleteSubControl,
	runSubControl,
	resetControl: resetControlVirtualState,
})

export default conn(Container)
